module.exports = __webpack_public_path__ + "static/media/SO6510F2.d5793fd0.png";